import ErrorComponent from "@src/components/errors";

import protectedMemberRoutes from "./modules/main/router/protected-routes";
import unprotectedMemberRoutes from "./modules/main/router/unprotected-routes";
import protectedMemberSettingsRoutes from "./modules/settings/router/protected-routes";

const routes = [
  {
    path: "",
    errorElement: <ErrorComponent />,
    children: [...protectedMemberRoutes, ...protectedMemberSettingsRoutes],
  },
  ...unprotectedMemberRoutes,
];

export default routes;
